import React, { ChangeEventHandler } from 'react';

import { Checkbox } from '@rbilabs/components-library/build/components/checkbox';
import { isFalse } from 'utils';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { PromotionalEmailsLabel } from '../checkbox-labels';

interface IPromotionalEmailsCheckbox {
  checked: boolean;
  disabled: boolean;
  onChange: ChangeEventHandler<HTMLInputElement>;
}

const PromotionalEmailsCheckbox: React.FC<IPromotionalEmailsCheckbox> = props => {
  const enableCommPrefFlag = useFlag(LaunchDarklyFlag.ENABLE_COMMUNICATION_PREFERENCES);
  const enableCommunicationPreferences = !isFalse(enableCommPrefFlag);
  return !enableCommunicationPreferences ? (
    <Checkbox label={<PromotionalEmailsLabel />} name="promotionalEmails" {...props} />
  ) : null;
};

export default PromotionalEmailsCheckbox;
